import _ from "lodash";
import { ADB_RATES } from "./AdbRates";
import { quoteConstant } from "@ipru-common/constants/SiteConstants";
import { OPTION_VALUES } from "@ipru-common/constants/InputValues";
import {
  addTax,
  calculateAdbCiFinalPremium,
  getChannelType,
  halfYearlyPremium,
  monthlyPremium,
} from "./QuoteCommonFunctions";
import { currencyToWord, removeHTO } from "./CommonFunctions";

export const findAdbPremium = (formFields) => {
  const { term, age, ADB_SA, SA, adb_selected, staff, paymentOption, channel, PPT } = formFields;

  const AdbTerm = _.min([term, 80 - parseInt(age)]);
  let rate = 0;
  if ([OPTION_VALUES.WLLP60, OPTION_VALUES.LP60].includes(paymentOption)) {
    rate = ADB_RATES?.WLLP60?.[PPT]?.[AdbTerm - quoteConstant.minPolicyTerm] || 0;
  } else {
    rate = ADB_RATES?.[paymentOption]?.[AdbTerm - quoteConstant.minPolicyTerm] || 0;
  }
  const interpolatedValue = getAnnualPremiumForAdBenefit({
    ADB_SA,
    SA,
    adb_selected,
    rate,
    paymentOption,
  });

  const annualPremium = calculateAdbCiFinalPremium(
    staff,
    formFields.platform,
    paymentOption,
    channel,
    formFields?.PPT,
    interpolatedValue,
    getChannelType(channel)
  );

  const { YEARLY, MONTHLY, HALF_YEARLY } = OPTION_VALUES.PAYMENT_TENURE;
  return {
    [YEARLY]: addTax(annualPremium),
    [MONTHLY]: addTax(monthlyPremium(annualPremium)),
    [HALF_YEARLY]: addTax(halfYearlyPremium(annualPremium)),
  };
};

const getAnnualPremiumForAdBenefit = ({ ADB_SA, SA, rate }) => {
  let result = SA;

  if (parseInt(ADB_SA) <= 20000000 && parseInt(ADB_SA) <= parseInt(SA) * 3) {
    result = Math.round((parseInt(ADB_SA) * rate) / 1000);
  } else {
    result = Math.round((parseInt(SA) * rate) / 1000);
  }

  return result;
};

export const createAdbSumAssuredDropdown = (lumpSum) => {
  const steps = [0.25, 0.5, 0.75, 3];

  let options = [];
  let lastOptValue = 0;

  for (let index = 0; index < steps.length; index++) {
    const percentage = steps[index];

    const optValue = removeHTO(parseInt(lumpSum) * percentage);
    const lowest = Math.min(lumpSum, quoteConstant.adbMaxLumpSum);

    if (optValue <= lowest) {
      options.push({ id: optValue, name: currencyToWord(optValue) });
      lastOptValue = optValue;
    } else {
      if (options.length < 4 && lastOptValue !== lowest) {
        options.push({
          id: lowest,
          name: currencyToWord(lowest),
        });
      }
      break;
    }
  }

  return options;
};
